import React from 'react'

export const ErrorLayer = () => {
  return (
    <div>ErrorLayer</div>
  )
}
